import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, FormGroup, Radio } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { AsyncCreatable } from 'react-select';
import { EditorState, convertFromRaw } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import 'react-select/dist/react-select.css';
import BasicFormInput from '../../form/BasicFormInput';
import FormSelect from '../../form/FormSelect';
import FormDateTime from '../../form/FormDateTime';
import FormEditor from '../../form/editor/FormEditor';
import FormTextArea from '../../form/FormTextArea';
import { CONVERT_HTML_OPTIONS, ESPORT_TYPE_OPTIONS } from '../../form/constants';
import BlitzAPI from '../../../api/BlitzAPI';
import { getUserOptions, getSourceOptions } from '../../../utils';
import { normalizeQuotes, formatTopImage } from '../../form/utils';
import FileToUrl from '../../form/FileToUrl';

const getTagOptions = (input) => {
  return BlitzAPI.getTags({ name: input }).then(
    (resp) => {
      return resp.data.data.map((tag) => {
        return { value: tag.id, label: tag.name };
      });
    },
  ).then((data) => { return { options: data }; });
};

class ExternalEntryForm extends Component {
  constructor(props) {
    super(props);

    const tags = props.tags && props.tags.map(
      (tag) => { return { label: tag.name, value: tag.id }; },
    );

    this.state = {
      sources: 11,
      useEditor: false,
      showOutput: false,
      authors: null,
      tags,
      type: 'article',
    };
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onEditorDataChange = this.onEditorDataChange.bind(this);
    this.toggleEditorButton = this.toggleEditorButton.bind(this);
    this.toggleOutputButton = this.toggleOutputButton.bind(this);
    this.createTag = this.createTag.bind(this);
  }

  componentDidMount() {
    BlitzAPI.getSources().then(
      (response) => {
        const sourceOptions = getSourceOptions(response);
        this.setState(
          {
            sources: sourceOptions,
          },
        );
      },
    );
    BlitzAPI.getUsers().then(
      (response) => {
        const userOptions = getUserOptions(response);
        this.setState(
          {
            authors: userOptions,
          },
        );
      },
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.tags !== nextProps.tags) {
      const tags = (nextProps.tags && nextProps.tags.map(
        (tag) => { return { label: tag.name, value: tag.id }; },
      )) || [];
      this.setState({ tags });
    }
  }

  onDeleteClick() {
    if (confirm('Delete this entry?')) {
      BlitzAPI.deleteEntry(this.props.entry_id).then(
        () => browserHistory.push('/entries/external'),
      );
    }
  }

  onEditorDataChange(event, newValue, previousValue) {
    const editorState = EditorState.createWithContent(convertFromRaw(newValue));
    const contentState = editorState.getCurrentContent();
    const html = convertToHTML(CONVERT_HTML_OPTIONS)(contentState);

    this.props.change('content', html);
  }

  createTag(val) {
    const { entry_id } = this.props;
    const { tags } = this.state;
    if (tags && tags.length > val.length) {
      const deleted = tags.filter(x => !(new Set(val).has(x)))[0];
      BlitzAPI.deleteEntryTag({ entry_id, tag_id: deleted.value });
    } else {
      const newItem = val.filter(x => !(new Set(tags).has(x)))[0];
      if (!Number.isInteger(newItem.value)) {
        BlitzAPI.postTag({ tag: { name: newItem.label } }).then(resp => BlitzAPI.postEntryTag(
          { entry_id, tag_id: resp.data.data.id },
        ));
      } else {
        BlitzAPI.postEntryTag({ entry_id, tag_id: newItem.value });
      }
    }

    this.setState({ tags: val });
  }

  toggleEditorButton() {
    this.setState({ useEditor: !this.state.useEditor });
  }

  toggleOutputButton() {
    this.setState({ showOutput: !this.state.showOutput });
  }

  onTypeChange(e, field) {
    const { change } = this.props;
    change(field, e.target.value);
    this.setState(
      {
        type: e.target.value,
      },
    );
  }

  render() {
    const { handleSubmit, onSubmit, submitting, published, url, type, change, top_image, cover_image, entry_id } = this.props;
    const { tags, sources, authors } = this.state;
    if (!(sources && authors)) {
      return <h1>Loading</h1>;
    }

    return (
      <form
        onSubmit={
          handleSubmit(
            v => onSubmit(
              Object.assign(v, { published: true }),
            ).then(() => browserHistory.push('/entries/external')),
          )
        }
        className="create-form-blitz"
      >
        <div className={`create-form-blitz-content ${entry_id ? 'create-form-blitz-content-edit' : ''}`}>
          <Field
            label="Entry Type"
            name="type"
            component={() => {
              return (
                <FormGroup className="create-form-type clearfix">
                  <Radio
                    onChange={e => this.onTypeChange(e, 'type')}
                    name="type" value={'article'} checked={type === 'article'} // eslint-disable-line camelcase
                  ><span>Article</span></Radio>
                  <Radio
                    onChange={e => this.onTypeChange(e, 'type')}
                    name="type" value={'youtube'} checked={type === 'youtube'} // eslint-disable-line camelcase
                  ><span>Video</span></Radio>
                  <Radio
                    onChange={e => this.onTypeChange(e, 'type')}
                    name="type" value={'feed'} checked={type === 'feed'} // eslint-disable-line camelcase
                  ><span>Blitzfeed</span></Radio>
                </FormGroup>
              );
            }}
          />
          <div className="form-section form-section-import">
            <div className="form-section-header">
              <h4 className="form-section-title">Import from a URL</h4>
              <h6 className="form-section-caption">Enter the URL of the external content to automatically fill out metadata.</h6>
            </div>
            <Field
              type="url"
              name="url"
              placeholder="Entry URL"
              component={BasicFormInput}
              controlId="entryURL"
              label="Entry URL"
            />
          </div>
          <div className="form-section">
            <Field
              type="text"
              name="title"
              placeholder="Title"
              component={BasicFormInput}
              controlId="entryTitle"
              label="Entry Title"
              normalize={normalizeQuotes}
            />
            {this.state.type !== 'feed' ?
            <Field
              name="description"
              component={FormTextArea}
              label="Description"
              normalize={normalizeQuotes}
            /> : null}
            {this.state.type !== 'feed' ?
            <Field
              name="share_description"
              component={FormTextArea}
              label="Share Description (FB/Twitter) (Optional)"
              normalize={normalizeQuotes}
            /> : null}
          </div>
          <div className={`form-section create-form-editor ${type !== 'feed' ? 'form-section-hidden' : ''}`}>
            <div className="form-section-header">
              <h4 className="form-section-title">Start Writing</h4>
              <h6 className="form-section-caption">Click the button below to write or edit your content.</h6>
            </div>
            <Button className="button-primary create-form-button-editor" onClick={this.toggleEditorButton} type="button">Toggle Editor</Button>
              {this.state.useEditor ?
              // TOGGLE THE EDITOR BASED ON THE BTUTON
              <div className={`create-form-editor-content ${this.state.showOutput ? 'create-form-editor-output-active' : ''}`}>
                <Field
                  name="data"
                  component={FormEditor}
                  onChange={this.onEditorDataChange}
                />
                <Field
                  name="content"
                  component={FormTextArea}
                  disabled={this.state.useEditor}
                />
                <div className="create-form-editor-output" onClick={this.toggleOutputButton}>{this.state.showOutput ? 'Hide code output' : 'Show code output'}</div>
              </div>
            :
              <Field
                name="data"
                component={FormTextArea}
                className="create-form-editor-placeholder"
              />
            }
          </div>
          {this.state.type !== 'feed' ?
          <div className="form-section create-form-image">
            <div className="form-section-header">
              <h4 className="form-section-title">Set Cover Image</h4>
              <h6 className="form-section-caption">Upload a cover image or paste an image URL.</h6>
            </div>
            <div className="create-form-image-content clearfix">
              <div className="create-form-image-item clearfix">
                <Field
                  label="Cover Image"
                  name="cover_image"
                  component={BasicFormInput}
                  controlId="coverImage"
                  format={formatTopImage}
                />
                <FileToUrl onUrlChange={newUrl => change('cover_image', newUrl)} />
                {formatTopImage(cover_image) && <img className="create-form-image-thumbnail" src={formatTopImage(cover_image)} role="presentation" />}
              </div>
              <div className="create-form-image-item clearfix">
                <Field
                  label="Share Image"
                  name="top_image"
                  component={BasicFormInput}
                  controlId="topImage"
                  format={formatTopImage}
                />
                <FileToUrl onUrlChange={newUrl => change('top_image', newUrl)} />
                {formatTopImage(top_image) &&
                  <img className="create-form-image-thumbnail" src={formatTopImage(top_image)} role="presentation" />
                }
              </div>
            </div>
          </div>
          : null}
          <div className="form-section form-metadata-external">
            <div className="form-section-header">
              <h4 className="form-section-title">Metadata</h4>
            </div>
            <div className="form-section-content">
              <div className="form-section-content-row clearfix">
                <Field
                  label="Publish Date"
                  name="publish_date"
                  component={FormDateTime}
                  format={value => value && moment(value)}
                  controlId="entryPublishDate"
                />
              </div>
              <div className="form-section-content-row form-section-metadata-row clearfix">
                <Field
                  label="Source"
                  name="source_id"
                  component={FormSelect}
                  options={sources}
                />
                <Field
                  label="Esport"
                  name="esport"
                  component={FormSelect}
                  options={ESPORT_TYPE_OPTIONS}
                />
              </div>
            </div>
          </div>
          <div className="form-section">
            <div className="form-section-header">
              <h4 className="form-section-title">Extras</h4>
              <h6 className="form-section-caption">You can set extra information here - these are not required for you to publish.</h6>
            </div>
            <div className="form-section-content-row form-section-extras-row clearfix">
              <Field
                type="checkbox"
                name="show_mobile"
                placeholder="Show on Mobile App"
                component={BasicFormInput}
                normalize={v => !!v}
                controlId="show_mobile"
                label="Show on Mobile App"
              />
              <Field
                type="checkbox"
                name="show_web"
                normalize={v => !!v}
                placeholder="Show on Web"
                component={BasicFormInput}
                controlId="show_web"
                label="Show on Web"
              />
            </div>
            {entry_id ?
              <div className="create-entry-tags">
                <label className="control-label">Tags</label>
                <AsyncCreatable
                  loadOptions={getTagOptions}
                  ignoreCase={false}
                  onChange={this.createTag}
                  value={tags}
                  multi
                />
              </div>
            : null}
          </div>
        </div>
        <div className="create-entry-sidebar">
          <Button
            type="submit"
            className="button-primary button-full create-entry-publish"
            disabled={submitting}
          >
            {published ? 'Save' : 'Publish'}
          </Button>
          <Button
            className="button-secondary button-full create-entry-draft"
            onClick={
              handleSubmit(
                v => onSubmit(Object.assign(v, { published: false })).then(() => browserHistory.push('/entries/external')),
              )
            }
            disabled={submitting}
          >{published ? 'Unpublish' : 'Save as Draft'}</Button>
          <Button
            className="button-secondary button-full create-entry-draft"
            disabled={submitting}
            onClick={
              handleSubmit(v => onSubmit(v).then(resp => browserHistory.push(`/entries/external/${resp.data.data.id}`)))
            }
          >Save and Continue</Button>
          <Button
            disabled={submitting}
            onClick={
              () => window.open(url)
            }
            className="button-secondary button-full create-entry-preview"
          >Preview</Button>
          {entry_id ?
            <Button
              type="button"
              onClick={this.onDeleteClick}
              className="button-secondary button-full create-entry-delete"
              bsStyle="danger"
            >Delete</Button> : null}
        </div>
      </form>
    );
  }
}

const selector = formValueSelector('generic-entry');
function mapStateToProps(state) {
  return {
    entry_id: selector(state, 'id'),
    tags: selector(state, 'tags'),
    type: selector(state, 'type') || 'article',
    url: selector(state, 'url'),
    published: selector(state, 'published'),
    cover_image: selector(state, 'cover_image'),
    top_image: selector(state, 'top_image'),
  };
}


ExternalEntryForm = connect(
  mapStateToProps,
)(reduxForm({ form: 'generic-entry', enableReinitialize: true })(ExternalEntryForm));

ExternalEntryForm.propTypes = {
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  entry_id: PropTypes.number,
  change: PropTypes.func,
  tags: PropTypes.array,
  url: PropTypes.string,
  type: PropTypes.string,
  published: PropTypes.bool,
  submitting: PropTypes.bool,
};

export default ExternalEntryForm;



// WEBPACK FOOTER //
// ./src/cms/entry/external/ExternalEntryForm.js